import { render } from "./IconPlus.vue?vue&type=template&id=d6fb3236&scoped=true&ts=true"
import script from "./IconPlus.vue?vue&type=script&lang=ts"
export * from "./IconPlus.vue?vue&type=script&lang=ts"

import "./IconPlus.vue?vue&type=style&index=0&id=d6fb3236&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6fb3236"]])

export default __exports__